<div class="flex items-center gap-3 text-sm" [ngClass]="{ 'text-neutral-40 line-through': isCorrect() }">
  <span class="flex h-4 w-4 items-center justify-center">
    <pay-icon [shape]="IconNames.CheckmarkOutline" [size]="'xs'" [ngClass]="{ 'text-neutral-40': isCorrect() }" />
  </span>
  {{ this.requirementText() | translate }}
</div>
